module.exports = __webpack_public_path__ + "static/media/galleryImg28.e330caf0.jpg";